import LoomLogo from '@/assets/nzm-loom-logo.svg'
import classes from './logo.module.css'

export const Logo = () => <img className={classes.logo} src={LoomLogo} alt='Loom' />
